import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function BackButton() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/dashboard');
  };

  return (
    <button className="btn btn-secondary btn-sm mb-1" onClick={handleBack}>
      ← Back
    </button>
  );
}
